import React, { useState } from "react";
import heart from "../../assets/img/icons/heart.svg";
import flash from "../../assets/img/icons/flash.svg";
import star from "../../assets/img/icons/star.svg";
import redheart from "../../assets/img/icons/heartcopy.svg";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useAxios";
import PersianNumber from "../shared/PersianNumber";
const PlaceCard = ({
  img,
  isfast,
  rate,
  info,
  title,
  tip,
  cost,
  code,
  slug,
  id,
  wishlist,
  room,
  city,
  type
}) => {
  const [like, setlike] = useState(wishlist);
  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
  const apipostWishlist = useFetch({
    method: "post",
    url: `api/wishlist/${id}`,
    noHeader: false,
    trigger: false,
    formdata: true,
    argFunc: res => {
      setlike(true);
    }
  });
  const apiremoveWishlist = useFetch({
    method: "delete",
    url: `api/wishlist/${id}`,
    noHeader: false,
    trigger: false,
    formdata: true,
    argFunc: res => {
      setlike(false);
    }
  });
  const navigate = useNavigate();
  return (
    <div
      className="PlaceCard"
      onClick={() => {
        navigate(`/place/${code}/${slug}`);
      }}
    >
      <div className=" relative PlaceCard-img">
        {!like
          ? <div
              onClick={e => {
                e.stopPropagation();
                apipostWishlist.reFetch();
              }}
              className="absolute  top-[25px] right-[25px] center   cursor-pointer PlaceCard--heart"
            >
              <img
                src={heart}
                className="transition-all transition-shadow transition-[2s]"
              />
            </div>
          : <div
              onClick={(e) =>{   e.stopPropagation(); apiremoveWishlist.reFetch()}}
              className="absolute  top-[25px] right-[25px] center   cursor-pointer PlaceCard--heart"
            >
              <img src={redheart} />
            </div>}
        <img src={img} alt="img-place" className="PlaceCard-img" />
        {isfast &&
          <div className="fastreserv-icon">
            <div className="ml-[5.45px]">رزرو فوری</div>
            <img src={flash} />
          </div>}
      </div>
      <div className="d-flex-align justify-start mt-[19px] ">
        <img src={star} className="ml-[5px]" />

        <div className="text-[#12171C] text-[20px] mb-[-7px] font-[900]">
          <PersianNumber number={round(rate, 1)} />
        </div>
      </div>
      <div className="my-[10px] text-[#797D82] text-[15px] font-[500]  ">
{type}     ،   {city}  ، <PersianNumber number={room} /> اتاق
      </div>

      <h4 className="mb-[17px] text-[20px] font-[700] text-[#292D32]">
        {" "}{title}
      </h4>

      <div className="d-flex-space footer-card">
        <div className="flex price-box justify-end">
          <div className="pre-cost ml-[4px]">از</div>

          <div className="cost">
            {cost && <PersianNumber number={cost}/>}
          </div>
          <div className="pre-cost">تومان</div>
        </div>

        {tip &&
          <div className="tip-box flex">
            <div>%</div>

            <div className="mx-[3px]">
              {tip}
            </div>

            <div> تخفیف </div>
          </div>}
      </div>
    </div>
  );
};

export default PlaceCard;
